import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { Form, Button, Input, Modal } from 'antd';
import { changePasswordAsync } from '../../api/api';
import '../../css/modal.scss';
import Const from "../../const";
import image from '../../res/image';
import {modalErrorStyle} from "../../lib/util/codeUtil";

const FormItem = Form.Item;

class PasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.formRef = React.createRef();
  }

  validatePassword = (_, value) => {
    const nowPassword = this.formRef.current.getFieldValue('now');
    const newPassword = this.formRef.current.getFieldValue('new');
    if (nowPassword === newPassword) {
      return Promise.reject(
        new Error('사용 중인 비밀번호의 재사용은 불가능합니다.')
      );
    }
    // const regExp = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,15}$/;
    const regExp = /^[A-Za-z0-9]{4,20}$/;
    if (!regExp.test(value)) {
      // return Promise.reject(new Error('영문, 숫자, 특수문자 조합 8~15자로 입력'));
      return Promise.reject(new Error('4자 ~ 20자로 입력해 주세요.'));
    }
    return Promise.resolve();
  };
  validatePasswordCheck = (_, value) => {
    const newPassword = this.formRef.current.getFieldValue('new');
    if (!newPassword || (newPassword && newPassword !== value)) {
      return Promise.reject(new Error('비밀번호가 일치하지 않습니다.'));
    }
    return Promise.resolve();
  };
  handleSubmit = async () => {
    const form = this.formRef.current;
    const result = await changePasswordAsync(
      form.getFieldValue('now'),
      form.getFieldValue('new')
    );
    if (result === 'SUCCESS') {
      this.props.alert.show('비밀번호를 변경하였습니다!!');
      this.props.close();
    } else {
      Modal.error({
        title: '비밀번호 변경 실패',
        content: (
          <div>
            {result === 'CURRENT_PASSWORD_NOT_MATCH'
              ? `기존 비밀번호가 일치하지 않습니다.`
              : `시스템에러로 배달요청에 실패하였습니다. 잠시 후 다시 시도해주세요.`}
          </div>
        ),
        ...modalErrorStyle,
        onOk() {},
      });
    }
  };

  render() {
    const { isOpen, close } = this.props;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
    };
    const skinType = Const.skinType.toUpperCase();

    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-overlay" onClick={close} />
            <div className="Modal">
              <div className="pw-title">비밀번호 변경</div>
              <div className="pw-image" onClick={close}>
                <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
              </div>
              <div className="pw-content">
                <Form
                  ref={this.formRef}
                  {...formItemLayout}
                  onFinish={this.handleSubmit}>
                  <div>
                    <div className="pw-content-text">기존 비밀번호</div>
                  </div>
                  <div className="pw-content-text-input">
                    <FormItem
                      name="now"
                      rules={[
                        {
                          required: true,
                          message: '기존 비밀번호를 입력해 주세요',
                        },
                      ]}>
                      <Input.Password
                        id="input-03"
                        placeholder={'기존 비밀번호를 입력해 주세요'}
                      />
                    </FormItem>
                    {/* <input type="password" id="now" placeholder="기존 비밀번호를 입력해 주세요" /> */}
                  </div>
                  <div>
                    <div className="pw-content-text2">새 비밀번호</div>
                  </div>
                  <div className="pw-content-text2-input">
                    <FormItem
                      name="new"
                      rules={[{ validator: this.validatePassword }]}>
                      {/* <Input.Password id="input2" placeholder={'영 소문자 + 숫자 10자 ~ 20자 조합해 입력해 주세요'} /> */}
                      <Input.Password
                        id="input-03"
                        placeholder={'4자 ~ 20자로 입력해 주세요.'}
                      />
                    </FormItem>
                    {/* <input type="password" id="new" placeholder="영 소문자 + 숫자 10자 ~ 20자 조합해 입력해 주세요 " /> */}
                  </div>
                  <div>
                    <div className="pw-content-text3">새 비밀번호 확인</div>
                  </div>
                  <div className="pw-content-text3-input">
                    <FormItem
                      name="new2"
                      rules={[{ validator: this.validatePasswordCheck }]}>
                      <Input.Password
                        id="input-03"
                        placeholder={'새 비밀번호를 입력해 주세요.'}
                      />
                    </FormItem>
                    {/* <input type="password" id="new2" placeholder="새 비밀번호를 다시 입력해 주세요" /> */}
                  </div>

                  <div className="pw-content-btn">
                    <Button
                      className={skinType === "GOGOIT" ? "gogoit-pw-content-btn-box" : "pw-content-btn-box"}
                      type="primary"
                      htmlType="submit">
                      확인
                    </Button>
                    {/* <div className="pw-content-btn-box" onClick={() => { }}>
                                            확인
                                        </div> */}
                    <div className={skinType === "GOGOIT" ? "gogoit-pw-content-btn-box2" : "pw-content-btn-box2"} onClick={close}>
                      취소
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

export default withAlert()(PasswordModal);
